import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaSave, FaFilm, FaTv, FaSync } from 'react-icons/fa';


const formatAutoSyncLog = (logData) => {
  if (!logData) return 'Nenhum log encontrado.';

  if (typeof logData === 'string') {
    try {
      const parsed = JSON.parse(logData);

      if (Array.isArray(parsed.lines)) {
        return parsed.lines
          .map(item => item.message || '')
          .filter(Boolean)
          .join('\n');
      }

      return logData;
    } catch (e) {
      return logData;
    }
  }

  if (Array.isArray(logData.lines)) {
    return logData.lines
      .map(item => item.message || '')
      .filter(Boolean)
      .join('\n');
  }

  return 'Nenhum log encontrado.';
};


const BACKEND_URL = '';

const AutoSyncPage = () => {
  const [movieUrl, setMovieUrl] = useState('');
  const [seriesUrl, setSeriesUrl] = useState('');

  const [isLoadingMovies, setIsLoadingMovies] = useState(false);
  const [isLoadingSeries, setIsLoadingSeries] = useState(false);

  const [movieCount, setMovieCount] = useState(0);
  const [seriesCount, setSeriesCount] = useState(0);

  const [error, setError] = useState('');
  const [syncLog, setSyncLog] = useState(null);

  const [movieBouquets, setMovieBouquets] = useState([]);
  const [seriesBouquets, setSeriesBouquets] = useState([]);

  const [selectedMovieBouquets, setSelectedMovieBouquets] = useState([]);
  const [selectedSeriesBouquets, setSelectedSeriesBouquets] = useState([]);

  useEffect(() => {
    fetchExistingUrls();
    fetchSyncLog();
    fetchBouquets('movies');
    fetchBouquets('series');
  }, []);

  const fetchExistingUrls = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/autosync/urls`);
      setMovieUrl(response.data.movieUrl || '');
      setSeriesUrl(response.data.seriesUrl || '');
      setMovieCount(response.data.movieCount || 0);
      setSeriesCount(response.data.seriesCount || 0);
    } catch (err) {
      setError('Erro ao buscar URLs existentes');
      console.error(err);
    }
  };

  const fetchSyncLog = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/autosync/log`);
      setSyncLog(response.data);
    } catch (err) {
      console.error('Erro ao buscar log de sincronização:', err);
    }
  };

  const fetchBouquets = async (type) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/autosync/bouquets?type=${type}`);
      const bouquets = response.data.bouquets || [];
      const selected = (response.data.selected || []).map(Number);

      if (type === 'movies') {
        setMovieBouquets(bouquets);
        setSelectedMovieBouquets(selected);
      }

      if (type === 'series') {
        setSeriesBouquets(bouquets);
        setSelectedSeriesBouquets(selected);
      }
    } catch (err) {
      console.error(`Erro ao buscar bouquets de ${type}:`, err);
      setError('Erro ao buscar bouquets');
    }
  };

  const saveBouquets = async (type, bouquetIds) => {
    await axios.post(`${BACKEND_URL}/api/autosync/bouquets`, {
      type,
      bouquetIds: bouquetIds.map(Number)
    });
  };

  const toggleBouquet = (id, selectedList, setSelectedList) => {
    const numericId = Number(id);

    if (selectedList.map(Number).includes(numericId)) {
      setSelectedList(selectedList.filter(item => Number(item) !== numericId));
    } else {
      setSelectedList([...selectedList, numericId]);
    }
  };

  const renderBouquetSelector = (title, bouquets, selectedList, setSelectedList) => {
    return (
      <div className="movie-page__form-group">
        <label style={{ marginBottom: '10px', display: 'block' }}>{title}</label>

        {bouquets.length === 0 && (
          <p className="movie-page__stats-card">Nenhum bouquet encontrado.</p>
        )}

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '10px',
          marginTop: '10px',
          marginBottom: '18px'
        }}>
          {bouquets.map((bouquet) => (
            <label
              key={bouquet.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: '10px',
                padding: '12px 14px',
                border: '1px solid rgba(255,255,255,0.15)',
                borderRadius: '8px',
                cursor: 'pointer',
                minHeight: '48px',
                width: 'auto'
              }}
            >
              <input
                type="checkbox"
                checked={selectedList.map(Number).includes(Number(bouquet.id))}
                onChange={() => toggleBouquet(bouquet.id, selectedList, setSelectedList)}
                style={{
                  width: '16px',
                  height: '16px',
                  minWidth: '16px',
                  margin: 0,
                  padding: 0,
                  cursor: 'pointer'
                }}
              />
              <span style={{
                flex: 1,
                textAlign: 'left',
                whiteSpace: 'normal',
                wordBreak: 'normal'
              }}>
                {bouquet.bouquet_name}
              </span>
            </label>
          ))}
        </div>
      </div>
    );
  };

  const handleSaveMovieUrl = async () => {
    setIsLoadingMovies(true);
    setError('');

    try {
      await saveBouquets('movies', selectedMovieBouquets);

      if (movieUrl.trim()) {
        const response = await axios.post(`${BACKEND_URL}/api/autosync/movies`, { url: movieUrl });
        setMovieCount(response.data.movieCount);
        alert('URL e bouquets de filmes salvos com sucesso!');
      } else {
        alert('Bouquets de filmes salvos com sucesso!');
      }
    } catch (err) {
      setError('Erro ao salvar URL ou bouquets de filmes');
      console.error(err);
    } finally {
      setIsLoadingMovies(false);
    }
  };

  const handleSaveSeriesUrl = async () => {
    setIsLoadingSeries(true);
    setError('');

    try {
      await saveBouquets('series', selectedSeriesBouquets);

      if (seriesUrl.trim()) {
        const response = await axios.post(`${BACKEND_URL}/api/autosync/series`, { url: seriesUrl });
        setSeriesCount(response.data.seriesCount);
        alert('URL e bouquets de séries salvos com sucesso!');
      } else {
        alert('Bouquets de séries salvos com sucesso!');
      }
    } catch (err) {
      setError('Erro ao salvar URL ou bouquets de séries');
      console.error(err);
    } finally {
      setIsLoadingSeries(false);
    }
  };

  return (
    <div className="movie-page">
      <h1 className="movie-page__title">AutoSync</h1>

      {error && <p className="movie-page__error">{error}</p>}

      <div className="movie-page__card">
        <h2 className="movie-page__card-title">URL de Filmes</h2>

        <div className="movie-page__form-group">
          <label htmlFor="movie-url">
            <FaFilm /> URL de Filmes:
          </label>
          <input
            type="text"
            id="movie-url"
            value={movieUrl}
            onChange={(e) => setMovieUrl(e.target.value)}
            placeholder="http://exemplo.com:porta/..."
          />
        </div>

        {renderBouquetSelector(
          'Bouquets de Filmes:',
          movieBouquets,
          selectedMovieBouquets,
          setSelectedMovieBouquets
        )}

        <button
          onClick={handleSaveMovieUrl}
          disabled={isLoadingMovies}
          className="movie-page__btn movie-page__btn--primary"
        >
          <FaSave /> {isLoadingMovies ? 'Salvando...' : 'Salvar Filmes'}
        </button>

        {movieCount > 0 && (
          <p className="movie-page__stats-card">Total de filmes: {movieCount}</p>
        )}
      </div>

      <div className="movie-page__card">
        <h2 className="movie-page__card-title">URL de Séries</h2>

        <div className="movie-page__form-group">
          <label htmlFor="series-url">
            <FaTv /> URL de Séries:
          </label>
          <input
            type="text"
            id="series-url"
            value={seriesUrl}
            onChange={(e) => setSeriesUrl(e.target.value)}
            placeholder="http://exemplo.com:porta/..."
          />
        </div>

        {renderBouquetSelector(
          'Bouquets de Séries:',
          seriesBouquets,
          selectedSeriesBouquets,
          setSelectedSeriesBouquets
        )}

        <button
          onClick={handleSaveSeriesUrl}
          disabled={isLoadingSeries}
          className="movie-page__btn movie-page__btn--primary"
        >
          <FaSave /> {isLoadingSeries ? 'Salvando...' : 'Salvar Séries'}
        </button>

        {seriesCount > 0 && (
          <p className="movie-page__stats-card">Total de séries: {seriesCount}</p>
        )}
      </div>

      {syncLog && (
        <div className="movie-page__card">
          <h2 className="movie-page__card-title">
            <FaSync /> Log de Sincronização
          </h2>
          <pre className="movie-page__log">
            {formatAutoSyncLog(syncLog)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default AutoSyncPage;
